import { render, staticRenderFns } from "./practiceExercises.vue?vue&type=template&id=727e906d&scoped=true"
import script from "./practiceExercises.vue?vue&type=script&lang=js"
export * from "./practiceExercises.vue?vue&type=script&lang=js"
import style0 from "./practiceExercises.vue?vue&type=style&index=0&id=727e906d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727e906d",
  null
  
)

export default component.exports